import React from 'react';
import { Box, SxStyleProp } from 'rebass';

export const HorizontalDivider: React.FC<{
  as?: React.ElementType;
  styles?: SxStyleProp;
}> = ({ styles }) => (
  <Box
    as="hr"
    sx={{ ...(styles ? styles : {}) }}
    role="presentation"
    variant="dividers.horizontal"
  />
);

export const VerticalDivider: React.FC<{
  as?: React.ElementType;
  styles?: SxStyleProp;
}> = ({ styles }) => (
  <Box
    as="hr"
    sx={{ ...(styles ? styles : {}) }}
    role="presentation"
    variant="dividers.vertical"
  />
);
